import { useEffect, useState } from "react";

const calc = (iso) => Math.max(0, Math.floor((new Date(iso).getTime() - Date.now()) / 1000));

export const useCountdown = (iso) => {
  const [left, setLeft] = useState(() => (iso ? calc(iso) : 0));
  useEffect(() => {
    if (!iso) return;
    setLeft(calc(iso));
    const t = setInterval(() => setLeft(calc(iso)), 1000);
    return () => clearInterval(t);
  }, [iso]);
  return left;
};

export const fmtTime = (s) => `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

export const CountdownBadge = ({ iso, testId }) => {
  const left = useCountdown(iso);
  return (
    <div data-testid={testId} className={`font-mono text-2xl font-extrabold tabular-nums ${left < 60 ? "text-[var(--x-red)]" : "text-white"}`}>
      {fmtTime(left)}
    </div>
  );
};
